import { useState, useEffect } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import AccountsTable from './AccountsTable';
import SelectedAccountsList from './SelectedAccountsList';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    padding: theme.spacing(1),
    flex: 1,
    minHeight: 0,
  },
  gridContainer: {
    height: '100%',
    display: 'flex',
    gap: theme.spacing(2),
    minWidth: 1000,
    maxWidth: '90vw',
    minHeight: 450,
    maxHeight: 'calc(100vh - 400px)',
  },
  tableSection: {
    flex: '1 1 65%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    padding: theme.spacing(3),
  },
  listSection: {
    flex: '1 1 35%',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    padding: theme.spacing(3),
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    borderBottom: '2px solid rgba(25, 118, 210, 0.1)',
  },
}));

const Step1TableSelection = ({
  accountUuid,
  selectedAccounts = [],
  onSelectionChange,
  isLoading = false
}) => {
  const classes = useStyles();
  const [localSelectedAccounts, setLocalSelectedAccounts] = useState(selectedAccounts);

  // Sync with parent component
  useEffect(() => {
    setLocalSelectedAccounts(selectedAccounts);
  }, [selectedAccounts]);

  const handleSelectionChange = (newSelection) => {
    setLocalSelectedAccounts(newSelection);
    if (onSelectionChange) {
      onSelectionChange(newSelection);
    }
  };

  const handleRemoveAccount = (accountToRemove) => {
    const newSelection = localSelectedAccounts.filter(
      account => account.uuid !== accountToRemove.uuid &&
                 account.businessName !== accountToRemove.businessName
    );
    handleSelectionChange(newSelection);
  };

  return (
    <div className={classes.container}>
      <div className={classes.gridContainer}>
        {/* Left side - Table */}
        <div className={classes.tableSection}>
          <Typography className={classes.sectionTitle}>
            Available Accounts
          </Typography>
          <AccountsTable
            accountUuid={accountUuid}
            selectedAccounts={localSelectedAccounts}
            onSelectionChange={handleSelectionChange}
            isLoading={isLoading}
          />
        </div>

        {/* Right side - Selected List */}
        <div className={classes.listSection}>
          <Typography className={classes.sectionTitle}>
            Accounts to Add
          </Typography>
          <SelectedAccountsList
            selectedAccounts={localSelectedAccounts}
            onRemoveAccount={handleRemoveAccount}
            maxHeight="480px"
          />
        </div>
      </div>
    </div>
  );
};

export default Step1TableSelection;
